// action - state management
import { ACCOUNT_INITIALIZE, LOGIN, LOGOUT, SET_TENANT } from './actions';

// ===========================|| ACCOUNT REDUCER ||=========================== //

const accountReducer = (state, action) => {
    switch (action.type) {
        case ACCOUNT_INITIALIZE: {
            const { isLoggedIn, user } = action.payload;
            return {
                ...state,
                isLoggedIn,
                isInitialized: true,
                user
            };
        }
        case LOGIN: {
            const { user } = action.payload;
            return {
                ...state,
                isLoggedIn: true,
                user
            };
        }
        case LOGOUT: {
            return {
                ...state,
                isLoggedIn: false,
                user: null
            };
        }
        case SET_TENANT: {
            const { tenant } = action.payload;
            return {
                ...state,
                tenant
            };
        }
        default: {
            return { ...state };
        }
    }
};

export default accountReducer;
